import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TravelRequestSummary,
  type TravelRequestSummaryConstructor,
} from './TravelRequestSummary'
import { TravelStatuses } from '../enums/TravelStatusEnum'
import { TravelApprovalLogConstructorFactory } from '../TravelApprovalLog'
import { TravelDestinationConstructorFactory } from '../TravelDestination'

export const TravelRequestSummaryConstructorFactory =
  Factory.Sync.makeFactory<TravelRequestSummaryConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    status: TravelStatuses.PENDING,
    travelBudget: Factory.each(() => faker.random.number()),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    dateCreated: Factory.each(() => faker.date.past().toISOString()),
    dateLastModified: Factory.each(() => faker.date.past().toISOString()),
    requester: Factory.each(() => ({
      id: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      email: faker.internet.email(),
    })),
    nextApprover: null,
    primaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.address.city(),
    })),
    secondaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.commerce.department(),
    })),
    destinations: Factory.each(() => [
      TravelDestinationConstructorFactory.build(),
    ]),
    logs: Factory.each(() => [TravelApprovalLogConstructorFactory.build()]),
    nextApproverChoices: null,
    delegatedBy: null,
  })

export const TravelRequestSummaryFactory = EntityFactory(
  TravelRequestSummary,
  TravelRequestSummaryConstructorFactory
)
